import React, { useEffect } from "react";
import Joyride, { STATUS, ACTIONS } from "react-joyride";
import ProjectTooltip from "./ProjectTooltip";

const ProductTour = ({ run, steps, onFinish, onClose }) => {

  // Failsafe: always release any scroll lock Joyride leaves behind
  useEffect(() => {
    if (!run) {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      document.documentElement.style.overflow = "";
    };
  }, [run]);

  return (
    <Joyride
      run={run}
      steps={steps}
      continuous
      showSkipButton
      scrollToFirstStep
      disableOverlayClose
      disableBeacon
      disableScrollParentFix   // ✅ stop Joyride from locking the nearest scroll parent
      tooltipComponent={ProjectTooltip}
      styles={{
        options: { primaryColor: "#4318FF", zIndex: 999999 },
        overlay: { backgroundColor: "transparent", mixBlendMode: "unset" },
        spotlight: { backgroundColor: "transparent" },
      }}
      callback={(data) => {
        const { status, action } = data;

        if (status === STATUS.FINISHED) { onFinish(); return; }
        if (status === STATUS.SKIPPED) { onFinish(); return; }
        if (action === ACTIONS.CLOSE) { onClose(); return; }
      }}
    />
  );
};

export default ProductTour;